import { useEffect, useState } from 'react';

const useIsTruncated = (text: string) => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    const measure = () => setIsTruncated(element.scrollWidth > element.clientWidth + 1);
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, text]);

  return { ref: setElement, isTruncated };
};

export default useIsTruncated;
